import { useContext } from "react";
import { useQuery } from "react-query";
import {
  IGetNumLotteryAndQuestionnairesInput,
  IGetNumLotteryAndQuestionnairesOutput,
} from "../../../api-schema/sumary";
import { AuthContext } from "../contexts/AuthProvider";
import { getRequest } from "./apiClient";

const SUMMARY_ENDPOINT = "summary";
const buildSummaryCacheKey = ({
  bId,
}: IGetNumLotteryAndQuestionnairesInput) => [bId, SUMMARY_ENDPOINT];

/**
 * 店舗サマリーを取得する
 * @param param0 対象のBid(オブジェクト)
 * @param token ログイン中のユーザーのトークン
 * @returns
 */
const getSummary = async (
  { bId }: IGetNumLotteryAndQuestionnairesInput,
  token: string
) => {
  const result = await getRequest<IGetNumLotteryAndQuestionnairesOutput>(
    SUMMARY_ENDPOINT,
    {
      bId,
    },
    token
  );
  return result;
};

/**
 *  店舗サマリーを取得する。すでに取得済みのときはキャッシュから返す。
 * @param param0 対象店舗のBid(オブジェクト)
 * @returns
 */
export const useSummaryData = ({
  bId,
}: IGetNumLotteryAndQuestionnairesInput) => {
  const { token } = useContext(AuthContext);
  const { data, isError, isLoading } =
    useQuery<IGetNumLotteryAndQuestionnairesOutput>(
      buildSummaryCacheKey({ bId }),
      () => getSummary({ bId }, token)
    );
  return { data, isError, isLoading };
};
